<template>
    <div class="order-service-list">
      <div v-if='model.length > 0'>
        <div class="f12">服务:</div>
        <ul class="list">
          <li v-for="(item, index) in model" :key="index" v-if='index <= 2'>
            <span>{{item.name}}</span>
            <span>¥{{item.price}}x{{item.serviceCount}}</span>
          </li>

          <li v-for="(item, index) in model" :key="index" v-if='index > 2' v-show='hidden'>
            <span>{{item.name}}x{{item.serviceCount}}</span>
            <span>¥{{item.price}}x{{item.serviceCount}}</span>
          </li>
        </ul>
      </div>
      <div class="arrow drop" :class='{up:hidden}' @click="toggle" v-if='model.length > 3'></div>
    </div>
</template>

<script>
  export default {
    name: 'com-online-name',
    props: {
      model : {
        type : Array,
        default : () => []
      }
    },
    data () {
      return {
        hidden : false
      }
    },
    created(){
      // console.log(this.model)
    },
    methods: {
      toggle () {
        this.hidden = !this.hidden;
      }
    }
  }
</script>

<style scoped lang="scss">
  .order-service-list{
    width: 100%;
    display: flex;
    flex-direction: column;
    &>div{
      display: flex;
      .list{
        flex: auto;
        margin: 0 30px 0 20px;
        position: relative;
        top:-5px;
        li{
          width: 100%;
          display: flex;
          line-height: 34px;
          justify-content: space-between;
          margin-bottom: 8px;
        }
      }
    }
    .arrow{
      width: 100%;
      height: 30px;
      display: flex;
      justify-content: center;
    }
    .drop{
      background: url("/images/public/arrow-down.png") no-repeat center;
      background-size: 22px 12px;
    }
    .up{
      background: url("/images/public/arrow-up.png") no-repeat center;
      background-size: 22px 12px;
    }
  }
</style>
